var exports = {
  "Lg": "x52a3aa3b--f8cc31--navigation",
  "b0": "x52a3aa3b--f8cc31--is-authenticated",
  "ro": "x52a3aa3b--f8cc31--is-wide-special-promo",
  "p_": "x52a3aa3b--f8cc31--list",
  "nf": "x52a3aa3b--f8cc31--link",
  "x3": "x52a3aa3b--f8cc31--list-item",
  "yo": "x52a3aa3b--f8cc31--hovered",
  "vu": "x52a3aa3b--f8cc31--active",
  "q4": "x52a3aa3b--f8cc31--invisible",
  "ul": "x52a3aa3b--f8cc31--special-promos",
  "r": "x52a3aa3b--f8cc31--has-special-promo",
};

module.exports = exports;
